import api from '../../api'

const SET_DEPARTMENTS = 'SET_DEPARTMENTS'
const ADD_DEPARTMENT = 'ADD_DEPARTMENT'

export default {
  namespaced: true,
  state: {
    departments: {}
  },
  getters: {
    getDepartments (state) {
      return state.departments
    },
  },
  mutations: {
    [SET_DEPARTMENTS]: (state, departments) => {
      state.departments = departments
    },
    [ADD_DEPARTMENT]: (state, department) => {
      let item = {}
      item[department.code] = department
      state.departments = Object.assign({}, state.departments, item)
    }
  },
  actions: {
    loadDepartments: async ({commit}) => {
      let response = await api.departments.list()
      if (response.success) {
        commit(SET_DEPARTMENTS, response.departments)
      } else {
        throw new Error(response.message || 'Произошла ошибка при загрузке списка кафедр')
      }
    },
    getDepartments: async ({commit}) => {
      let response = await api.departments.list()
      if (response.success) {
        commit(SET_DEPARTMENTS, response.departments)
      } else {
        throw new Error(response.message || 'Произошла ошибка при загрузке списка кафедр')
      }
    },
    getDepartment: async ({commit}, code) => {
      let response = await api.departments.department(code)
      if (response.success) {
        commit(ADD_DEPARTMENT, response.department)
      }
    },
    saveDepartment: async ({commit}, department) => {
      let response = await api.departments.save(department)
      if (response.success) {
        commit(ADD_DEPARTMENT, response.department)
      }
    }
  },
}
